module.exports = __webpack_public_path__ + "static/media/close.ba4b1660.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Lightbox/close.svg
// module id = 1084
// module chunks = 0